import { useEffect, useState } from 'react';
import { isRightResult } from '../lib/trpcTypeGuards';
import type { TRPC } from '../contexts/TRPC';

interface PresetOption {
  id: string;
  name: string;
}

export function useModeratorPresets({
  enabled,
  trpc,
}: {
  enabled: boolean;
  trpc: TRPC;
}): PresetOption[] {
  const [presets, setPresets] = useState<PresetOption[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const loadPresets = async () => {
      try {
        const result = await trpc.client.listModeratorPresets.query(undefined);
        if (!cancelled && isRightResult(result)) {
          setPresets(
            result.right.map((p: { id: string; name: string }) => ({
              id: p.id,
              name: p.name,
            })),
          );
        }
      } catch {
        /* presets are optional */
      }
    };
    void loadPresets();
    return () => {
      cancelled = true;
    };
  }, [enabled, trpc.client]);

  return presets;
}
